// Sales > Draft orders: orders written down but not placed (by the TearDrop
// Assistant, garageFarmServer routes/assistant.js). No stock was taken and
// nobody was charged or emailed; they never count in sales. Michael places
// the real order himself, then marks the draft placed or bins it.
import { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/auth';
import { Button, PageHeader, Pill } from '../lib/ui';
import { formatWhen } from '../lib/briefings';
import { useFlash, errorText } from './TradeCommon';
import AiTag from './AiTag';
import './Trade.css';
import './Briefings.css';

const ROUND = { morning: 'late morning', evening: 'early evening', late: 'late evening' };
const gbp = n => `£${Number(n || 0).toFixed(2)}`;
const day = d => (d ? new Date(d).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }) : '');

export default function OrderDrafts({ header }) {
  const [drafts, setDrafts] = useState(null);
  const { flash, banner } = useFlash();

  const load = useCallback(() => {
    api.get('/order-drafts').then(({ data }) => setDrafts(data)).catch(e => flash(errorText(e), 'bad'));
  }, [flash]);
  useEffect(() => { load(); }, [load]);

  const setStatus = async (d, status) => {
    try { await api.patch(`/order-drafts/${d._id}`, { status }); load(); } catch (e) { flash(errorText(e), 'bad'); }
  };

  return (
    <div className="dashboard-container">
      <PageHeader title="Sales" subtitle="Orders written down but not placed: no stock taken, nobody charged or emailed" {...header} />
      {banner}
      {!drafts && <p className="br-card__empty">Loading…</p>}
      {drafts && drafts.length === 0 && <p className="br-card__empty">No draft orders.</p>}
      {(drafts || []).map(d => (
        <div key={d._id} className="br-card" style={{ padding: '12px 16px', marginBottom: 10, opacity: d.status === 'placed' ? 0.6 : 1 }}>
          <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
            <strong>{d.customerName}</strong><AiTag record={d} />
            {d.status === 'placed' && <Pill tone="ok">Placed</Pill>}
            <span className="muted" style={{ fontSize: 13 }}>
              {[d.deliveryDate && day(d.deliveryDate), ROUND[d.deliverySlot], d.paymentMethod].filter(Boolean).join(', ') || 'no delivery details yet'}
            </span>
            <span style={{ marginLeft: 'auto', fontWeight: 700 }}>about {gbp(d.estimatedTotal)}</span>
          </div>
          <div style={{ marginTop: 6, fontSize: 14 }}>
            {d.items.map(it => `${it.quantity} x ${it.name} ${it.grams ? `${it.grams} g` : ''}`.trim()).join(', ')}
          </div>
          {d.notes && <div className="muted" style={{ marginTop: 4, fontSize: 13 }}>{d.notes}</div>}
          <div className="muted" style={{ marginTop: 4, fontSize: 12 }}>Written {formatWhen(d.createdAt)}</div>
          <div className="br-toolbar" style={{ margin: '8px 0 0' }}>
            {d.status === 'draft'
              ? <Button size="sm" onClick={() => setStatus(d, 'placed')}>Mark placed</Button>
              : <Button size="sm" variant="muted" onClick={() => setStatus(d, 'draft')}>Back to draft</Button>}
            <Button size="sm" variant="danger" onClick={() => { if (window.confirm('Bin this draft order?')) setStatus(d, 'binned'); }}>Bin</Button>
          </div>
        </div>
      ))}
    </div>
  );
}
